import './App.css';
import CourseStatistics from './CourseStatistics';
import { useState } from 'react';
import DataUploader from './DataUploader';
import CourseSelection from './CourseSelection';


function App() {
  const [data, setData] = useState(null);
  const [courseStatistics, setCourseStatistics] = useState(null);
  const [courseSelection, setCourseSelection] = useState(null);

  return (
    <div className="App">
      <main style={{ padding: '20px' }}>
        { !data ? (<DataUploader setData={setData} setCourseStatistics={setCourseStatistics} />) : null }
        { courseStatistics && !courseSelection ? (<CourseStatistics statisticsData={courseStatistics} setCourseSelection={setCourseSelection} />) : null }
        { courseSelection ? (<CourseSelection data={data} courseSelection={courseSelection} />) : null }
      </main>
    </div>
  );
}

export default App;
